// Router.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import AboutPage from "./Pages/AboutPage";
import Layout from "./Components/Layout/Layout";
import Contact from "./Components/Contact/Contact";
import Login from "./Components/Login/Login";
import Drain from "./Components/Services/Drain";
import Waste from "./Components/Services/Waste";
import Kitchen from "./Components/Services/Kitchen";
import Plumbing from "./Components/Services/Plumbing";
import Haulage from "./Components/Services/Haulage";
import Project from "./Components/Project/Project";
import NotFound from "./Components/NotFound.jsx/NotFound";
import DashBoardLayout from "./Components/DashboardLayout/DashBoardLayout";
import Inbox from "./Pages/Inbox";
import NewRequest from "./Pages/NewRequest";
import ServiceHistory from "./Pages/ServiceHistory";
import JobProgress from "./Pages/JobProgress";
import AdminLogin from "./Components/AdminLogin/AdminLogin";

import GetRequest from "./Pages/GetRequestPage";
import AdminDashboard from "./Components/AdminDashboard/AdminDashboard";
/*import ManageProfile from "./Pages/ManageProfilePage";*/
import AdminInbox from "./Pages/AdminInbox";
import DataVisualization from "./Components/DataVisualization/DataVisualization";
import ForgotPasswordPage from "./Pages/ForgotPasswordPage";
import DashboardManageProfile from "./Pages/DashboardManageProfile";
import QuotationsPage from "./Pages/QuotationsPage";
import ServiceRequestPage from "./Pages/ServiceRequestPage";
import Subscription from "./Pages/SubscriptionPage";
import ResetPassword from "./Components/ForgotPassword/ResetPassword";
import ServiceReport from "./Components/Report/ServiceReport";
import PrivateRoute from "./privaterouters";
const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout>
            <HomePage />
          </Layout>
        }
      />
      <Route
        path="/about"
        element={
          <Layout>
            <AboutPage />
          </Layout>
        }
      />
      <Route
        path="/contact"
        element={
          <Layout>
            <Contact />
          </Layout>
        }
      />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route
        path="/drain-unblocking"
        element={
          <Layout>
            <Drain />
          </Layout>
        }
      />
      <Route
        path="/waste-management"
        element={
          <Layout>
            <Waste />
          </Layout>
        }
      />
      <Route
        path="/kitchen"
        element={
          <Layout>
            <Kitchen />
          </Layout>
        }
      />

      <Route
        path="/plumbing"
        element={
          <Layout>
            <Plumbing />
          </Layout>
        }
      />

      <Route
        path="/haulage"
        element={
          <Layout>
            <Haulage />
          </Layout>
        }
      />

      <Route
        path="/project"
        element={
          <Layout>
            <Project />
          </Layout>
        }
      />

      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/not-found" element={<NotFound />} />
      {/* <Route path="/signup-success" element={<SignupSuccess />} />  Add this route */}
      {/*  Dashboard nested Routed */}

      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <DashBoardLayout />
          </PrivateRoute>
        }
      >
        <Route
          index
          element={
            <PrivateRoute>
              <Inbox />
            </PrivateRoute>
          }
        />
        <Route
          path="new-request"
          element={
            <PrivateRoute>
              <NewRequest />
            </PrivateRoute>
          }
        />
        <Route
          path="service-history"
          element={
            <PrivateRoute>
              <ServiceHistory />
            </PrivateRoute>
          }
        />
        <Route
          path="job-progress"
          element={
            <PrivateRoute>
              <JobProgress />
            </PrivateRoute>
          }
        />
        <Route
          path="manage-profile"
          element={
            <PrivateRoute>
              <DashboardManageProfile />
            </PrivateRoute>
          }
        />
      </Route>

      {/* nested routed ends here */}
      {/* Admin Route */}
      <Route path="/admin-dashboard" element={<AdminDashboard />}>
        <Route index element={<GetRequest />} />
        <Route path="get-request" element={<Inbox />} />
        <Route path="report" element={<ServiceReport />} />
        <Route path="job-progress" element={<JobProgress />} />
        {/* <Route path="data" element={<DataVisualization />} /> */}
        <Route path="inbox-admin" element={<AdminInbox />} />
        <Route path="quotations" element={<QuotationsPage />} />
        <Route path="service-request" element={<ServiceRequestPage />} />
        <Route path="subscription" element={<Subscription />} />
      </Route>

      <Route path="*" element={<Navigate to="/not-found" />} />
    </Routes>
  );
};

export default AppRoutes;
